import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import baseURL from "../../../utils/baseURL";
import {
  resetErrAction,
  resetSuccessAction,
} from "../globalActions/globalActions";
import { clearCartState } from "../cart/cartSlice";

//initialState
const initialState = {
  loading: false,
  error: null,
  users: [],
  user: null,
  profile: {},
  userAuth: {
    loading: false,
    error: null,
    userInfo: localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : null,
  },
  user: null,
  profile: null,
  loading: false,
  error: null,
};

//register action
export const registerUserAction = createAsyncThunk(
  "users/register",
  async (
    { email, password, fullname },
    { rejectWithValue, getState, dispatch }
  ) => {
    try {
      //make the http request
      const { data } = await axios.post(`${baseURL}/users/register`, {
        email,
        password,
        fullname,
      });
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);



export const updateUserShippingAddressAction = createAsyncThunk(
  "users/update-shipping-address",
  async (
    {
      nombre,
      paterno,
      direccion,
      colonia,
      delegacion,
      zipcode,
      estado,
      telefono
    },
    { rejectWithValue, getState, dispatch }
  ) => {
    console.log(
      nombre,
      paterno,
      direccion,
      colonia,
      delegacion,
      zipcode,
      estado,
      telefono
    );
    try {
      const token = getState()?.users?.userAuth?.userInfo?.token;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await axios.put(
        `${baseURL}/users/update/shipping`,
        {
          nombre,
          paterno,
          direccion,
          colonia,
          delegacion,
          zipcode,
          estado,
          telefono
        },
        config
      );
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);
//user profile action
export const getUserProfileAction = createAsyncThunk(
  "users/profile-fetched",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      //get token
      const token = getState()?.users?.userAuth?.userInfo?.token;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await axios.get(`${baseURL}/users/profile`, config);
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

//login action
export const loginUserAction = createAsyncThunk(
  "users/login",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${baseURL}/users/login`, {
        email,
        password,
      });
      localStorage.setItem("userInfo", JSON.stringify(data));
      return data;
    } catch (error) {
      console.log("=== ERROR DEBUG ===");
      console.log("Error status:", error.response?.status);
      console.log("Error data:", error.response?.data);
      
      // Make sure we're passing the error properly
      return rejectWithValue(error.response?.data);
    }
  }
);
//logout action
export const logoutAction = createAsyncThunk(
  "users/logout",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // Clear user info from localStorage
      localStorage.removeItem("userInfo");
      
      // Clear cart items from localStorage
      localStorage.removeItem("cartItems");
      
      // Dispatch action to clear cart from Redux state
      dispatch(clearCartState());
      
      return true;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//users slice

const usersSlice = createSlice({
  name: "users",
  initialState,
  extraReducers: (builder) => {
    //handle actions
    //login
    builder.addCase(loginUserAction.pending, (state, action) => {
      state.userAuth.loading = true;
    });
    builder.addCase(loginUserAction.fulfilled, (state, action) => {
      state.userAuth.userInfo = action.payload;
      state.userAuth.loading = false;
      state.userAuth.error = null;
    });
    builder.addCase(loginUserAction.rejected, (state, action) => {
      state.userAuth.error = action.payload;
      state.userAuth.loading = false;
    });
    //register
    builder.addCase(registerUserAction.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(registerUserAction.fulfilled, (state, action) => {
      state.user = action.payload;
      state.loading = false;
    });
    builder.addCase(registerUserAction.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
    });
    //logout
    builder.addCase(logoutAction.fulfilled, (state, action) => {
      state.userAuth.userInfo = null;
    });
     //profile - FIX THIS PART
    builder.addCase(getUserProfileAction.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getUserProfileAction.fulfilled, (state, action) => {
      // The API returns { userFound: {...} }
      state.profile = action.payload.userFound; // Store the userFound object directly
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getUserProfileAction.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
    });

    // update shipping address
    builder.addCase(
      updateUserShippingAddressAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      }
    );
    builder.addCase(
      updateUserShippingAddressAction.fulfilled, (state, action) => {
        state.loading = false;
        if (state.profile) {
          state.profile.shippingAddress = action.payload.shippingAddress;
        }
        if (state.user) {
          state.user.shippingAddress = action.payload.shippingAddress;
        }
        state.error = null;
      }
      
    );
    builder.addCase(
      updateUserShippingAddressAction.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      }
    );
    //reset error action
  builder.addCase(resetErrAction.pending, (state) => {
  state.userAuth.error = null;  // Clear the nested error
  state.error = null; // Also clear any top-level error
});
  },
});

//generate reducer
const usersReducer = usersSlice.reducer;

export default usersReducer;